module.exports = __webpack_public_path__ + "48070211cbc83cefb19af43a33b5682e.svg";